import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import jwt from "jwt-decode";
import DataListPage from "../../../components/DataListPage";
import TruncatedCell from "../../../components/TruncatedCell";
import claimFileService from "../../../services/claimFileService";
import claimLoginServices from "../../../services/claimLoginServices";
import { instanceToken } from "../../../utils/constant";

export default function ClaimFiles() {
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [offset, setOffset] = useState(0);
  const [count, setCount] = useState(0);
  const [claimFiles, setClaimFiles] = useState(null);
  const [search, setSearch] = useState("");

  const [values] = useState({
    username: "admin-1",
    password: "Secret@CBL$$SmartCart2025",
  });

  useEffect(() => {
    if (search === "") {
      fetchClaimFiles(rowsPerPage, offset);
    } else {
      fetchSearchByID(search);
    }
  }, [offset, rowsPerPage, search]);

  const fetchSearchByID = async (searchValue) => {
    try {
      const res = await claimFileService.searchCliamFile(
        instanceToken.token,
        searchValue
      );
      if (res.data) {
        const uniqueResults = Array.from(
          new Map(res.data.map((item) => [item.insurance_id, item])).values()
        );
        setClaimFiles(uniqueResults);
        setCount(uniqueResults.length);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchClaimFiles = async (limit, offset) => {
    try {
      const res = await claimFileService.getCliamFiles(
        instanceToken.token,
        limit,
        offset
      );
      parse(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const parse = (data) => {
    setClaimFiles(data.claim_files);
    setCount(data.count);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setOffset(rowsPerPage * newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setOffset(0);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(0);
    setOffset(0);
  };

  const handleDetailsClick = async (insurance_id) => {
    try {
      const response = await claimLoginServices.ClaimLogin({
        username: values.username,
        password: values.password,
      });

      const token = response.data.token;
      const decodedToken = jwt(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        console.log("Session expired");
        return;
      }

      const data = JSON.stringify({
        decodedToken,
        jwttoken: token,
      });
      window.localStorage.setItem("cblife_claimForm_token", data);

      navigate(`/claimFiles/${insurance_id}`);
    } catch (error) {
      console.error("Error during login or navigation:", error);
    }
  };

  const openDetail = (row) => handleDetailsClick(row.insurance_id);

  const columns = [
    {
      id: "insurance_id",
      label: "Insurance ID",
      render: (row) => <TruncatedCell value={row.insurance_id} />,
    },
  ];

  return (
    <DataListPage
      title="Claim Files"
      rows={claimFiles || []}
      columns={columns}
      count={count}
      page={page}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={[10, 25]}
      onPageChange={handleChangePage}
      onRowsPerPageChange={handleChangeRowsPerPage}
      search={{
        placeholder: "Search by claim form ID...",
        onSearch: handleSearch,
        showFilterButton: false,
      }}
      onView={openDetail}
      menuActions={[{ label: "View details", onClick: openDetail }]}
      getRowKey={(row, index) => row.insurance_id ?? index}
      loading={!claimFiles}
    />
  );
}
